import React from 'react';
import SecuredZone from '../SecuredZone/SecuredZone';
import Dialog from '@material-ui/core/Dialog';
import API from '../../../api/api';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Component } from 'react';
import { 
  Paper, 
  Box, 
  Typography, 
  Grid, 
  Card, 
  CardContent,
  IconButton,
  Tooltip
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import AdminAppointmentServicesDialog from '../../../dialogs/admin-appointment-services/admin-appointment-services';

const garageApi = new API();

class AdminAppointment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingServices: true,
      adminAppointmentServicesDialog: false,
      appointmentServices: [],
      editAppointmentService: {},
    };
  }

  componentDidMount() {
    this.loadAppointmentServices();
  }

  loadAppointmentServices() {
    garageApi.endpoints.appointmentServices.getAll()
      .then((getRequest) => {
        try {
          const services = Array.isArray(getRequest.data)
            ? getRequest.data
            : (getRequest.data?.results || []);
          this.setState({ 
            appointmentServices: services,
            loadingServices: false 
          });
        } catch(e) {
          console.log(e);
          this.setState({ 
            appointmentServices: [],
            loadingServices: false 
          });
        }
      })
      .catch(() => {
        this.setState({ 
          appointmentServices: [],
          loadingServices: false 
        });
      });
  }

  deleteAppointmentService(unikey) {
    if (!window.confirm('Möchten Sie diese Dienstleistung wirklich löschen?')) {
      return;
    }

    var deleteService = this.state.appointmentServices.find((element) => { return element.unikey === unikey; });
    if (!deleteService) return;

    this.setState({ loadingServices: true });

    garageApi.endpoints.appointmentServices.delete({ id: deleteService.id })
      .then(() => {
          this.loadAppointmentServices();
      })
      .catch(() => {
        this.setState({ loadingServices: false });
      });
  }

  closeAdminAppointmentServicesDialog() {
    this.setState({ adminAppointmentServicesDialog: false });
    this.setState({ editAppointmentService: {} });
  }

  submitAdminAppointmentServicesDialog(mode, service) {
    this.setState({ loadingServices: true });
    if(mode) {
      garageApi.endpoints.appointmentServices.create(service)
        .then(() => {
            this.loadAppointmentServices();
        })
        .catch(() => {
          this.setState({ loadingServices: false });
        });
    } else {
      garageApi.endpoints.appointmentServices.update(service)
        .then(() => {
            this.loadAppointmentServices();
        })
        .catch(() => {
          this.setState({ loadingServices: false });
        });
    }
    this.setState({ adminAppointmentServicesDialog: false });
    this.setState({ editAppointmentService: {} });
  }

  editAppointmentService(unikey) {
    var editService = this.state.appointmentServices.find((element) => { return element.unikey === unikey; });
    this.setState({ editAppointmentService: editService || {} });
    this.setState({ adminAppointmentServicesDialog: true });
  }

  createService() {
    this.setState({ adminAppointmentServicesDialog: true });
  }

  render() {
    const { 
      loadingServices, 
      appointmentServices, 
      adminAppointmentServicesDialog, 
      editAppointmentService
    } = this.state;

    return (
      <SecuredZone
        breadcrumbs={{ '/admin/': 'Dashboard', '/admin/appointment': 'Online Termin' }}
        menu={{ 
          'Dienstleistung Hinzufügen': this.createService.bind(this)
        }}
        title="Online Termin"
        loading={loadingServices ? <LinearProgress color="primary" /> : <span className="loader-span"></span>}
      >
        <Dialog 
          open={adminAppointmentServicesDialog} 
          onClose={this.closeAdminAppointmentServicesDialog.bind(this)}
          maxWidth="sm"
          fullWidth
        >
          <AdminAppointmentServicesDialog 
            appointmentServicesData={editAppointmentService} 
            close={this.closeAdminAppointmentServicesDialog.bind(this)} 
            submit={this.submitAdminAppointmentServicesDialog.bind(this)}
          />
        </Dialog>
        <Box style={{ padding: '20px' }}>
          {/* Dienstleistungen */}
          <Paper elevation={2} style={{ padding: '20px', marginBottom: '24px', background: 'linear-gradient(135deg, #388e3c 0%, #66bb6a 100%)', color: 'white' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box>
                <Typography variant="h5" style={{ fontWeight: 700, marginBottom: '8px' }}>
                  Dienstleistungen
                </Typography>
                <Typography variant="body1" style={{ opacity: 0.9 }}>
                  {appointmentServices.length} {appointmentServices.length === 1 ? 'Dienstleistung' : 'Dienstleistungen'} insgesamt
                </Typography>
              </Box>
              <AttachFileIcon style={{ fontSize: 50, opacity: 0.3 }} />
            </Box>
          </Paper>

          {!loadingServices && (
            <Grid container spacing={3} style={{ marginBottom: '40px' }}>
              {appointmentServices.length > 0 ? (
                appointmentServices.map((service) => (
                  <Grid item xs={12} sm={6} md={4} key={service.unikey || service.id}>
                    <Card 
                      style={{ 
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        position: 'relative',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-4px)';
                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                      }}
                    >
                      <CardContent style={{ flexGrow: 1, position: 'relative', padding: '16px' }}>
                        <Typography 
                          variant="h6" 
                          component="h3" 
                          style={{ 
                            fontWeight: 600, 
                            marginBottom: '12px',
                            minHeight: '32px'
                          }}
                        >
                          {service.title || 'Ohne Titel'}
                        </Typography>
                        <Typography 
                          variant="body2" 
                          color="textSecondary" 
                          style={{ 
                            marginBottom: '16px',
                            minHeight: '40px'
                          }}
                        >
                          {service.description || 'Keine Beschreibung'}
                        </Typography>
                        <Box 
                          style={{ 
                            position: 'absolute',
                            top: '16px',
                            right: '16px',
                            display: 'flex',
                            gap: '4px',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            borderRadius: '4px',
                            padding: '4px'
                          }}
                        >
                          <Tooltip title="Bearbeiten">
                            <IconButton 
                              size="small" 
                              onClick={() => { this.editAppointmentService(service.unikey); }}
                              style={{ color: '#1976d2', padding: '4px' }}
                            >
                              <EditIcon fontSize="small" />
                              </IconButton>
                          </Tooltip>
                          <Tooltip title="Löschen">
                            <IconButton 
                              size="small" 
                              onClick={() => { this.deleteAppointmentService(service.unikey); }}
                              style={{ color: '#d32f2f', padding: '4px' }}
                            >
                              <DeleteIcon fontSize="small" />
                              </IconButton>
                          </Tooltip>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Paper elevation={2} style={{ padding: '60px', textAlign: 'center' }}>
                    <AttachFileIcon style={{ fontSize: 80, color: '#ccc', marginBottom: '20px' }} />
                    <Typography variant="h6" color="textSecondary" style={{ marginBottom: '8px' }}>
                      Noch keine Dienstleistungen vorhanden
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Klicken Sie auf "Dienstleistung Hinzufügen" um Ihre erste Dienstleistung hinzuzufügen.
                    </Typography>
                  </Paper>
                </Grid>
              )}
            </Grid>
          )}

        </Box>
      </SecuredZone>
    );
  }
}

export default AdminAppointment;
